/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import moment from 'moment'

import {
  Heading,
  Table,
  PayrollCycleName,
  DeductionPaymentsTotal,
  CenteredContainerDisplay,
  PageNavigationButtons,
  Spinner
} from '../'

import {
  chunkArray
} from '../../utils'

const RIGHT_ARROW = <span style={{ fontSize: 20 }}>&rarr;</span>

class DeductionHistoricList extends React.Component {
  static propTypes = {
    historicDeductions: PropTypes.array.isRequired
  }

  state = {
    currentDeductionsToShow: [],
    currentPage: 0,
    pages: 0,
    mounted: false
  }

  componentDidMount() {
    let deductionsChunked = chunkArray(this.props.historicDeductions, 10)
    // if deduction listing results page was previously saved when clicked into detail view before, get and set the state accordingly
    let currentPageSaved = JSON.parse(sessionStorage.getItem('DeductionHistoricListCurrentPage'))
    this.setState({
      currentDeductionsToShow: deductionsChunked,
      currentPage: currentPageSaved || 0,
      pages: deductionsChunked.length,
      mounted: true
    }, () => currentPageSaved && sessionStorage.removeItem('DeductionHistoricListCurrentPage'))
  }

  render() {
    if (this.state.mounted === false) {
      return <Spinner type='brand' size='large' top={true} className='viewport-height-100' />
    }
    let deductions = this.state.pages > 0
      ? this.state.currentDeductionsToShow[this.state.currentPage].map((workflowrun, index) => {
          return [
            <tr
              onClick={() => {
                // 'remember'/save the current page in the listing results
                sessionStorage.setItem('DeductionHistoricListCurrentPage', this.state.currentPage)
                this.props.history.push(`/os/operations/general/deductions/history/${workflowrun.node.id}`)
              }}
              key={`historyRow_${index}`}>
              <td>
                {moment(workflowrun.node.payrollrunDeducted.paidOn).format('DD MMM YYYY')}
              </td>
              <td>
                <PayrollCycleName payrollCycleId={workflowrun.node.payrollrunDeducted.payrollcycle.id} />
              </td>
              <td>
                -
              </td>
              <td>
                <DeductionPaymentsTotal workflowRun={workflowrun.node.id} />
              </td>
              <td>
                <a style={{ textDecoration: 'none' }}>{RIGHT_ARROW}</a>
              </td>
            </tr>
          ]
        })
      : []

    return (
      <div className='slds-m-top_large'>
        {deductions.length === 0
          ? <CenteredContainerDisplay
              content={<Heading>No historic deductions to display</Heading>}
              height={500}
              yAdjustPercentage={-40}
            />
          : <React.Fragment>
              <Table
                columns={[
                  'For payday',
                  'Payroll cycle name',
                  'Division',
                  'Amount',
                  ''
                ]}
                rows={deductions}
                objectRows={true}
              />
              <PageNavigationButtons
                onNextClick={() => this.setState((prevState) => (
                  {
                    currentPage: prevState.currentPage + 1
                  }
                ))}
                onPreviousClick={() => this.setState((prevState) => (
                  {
                    currentPage: prevState.currentPage - 1
                  }
                ))}
                previousDisabled={this.state.currentPage === 0}
                nextDisabled={this.state.currentPage === this.state.pages}
                className='slds-p-around_medium slds-float_right'
              />
            </React.Fragment>
        }
      </div>
    )
  }
}

export default withRouter(DeductionHistoricList)



// WEBPACK FOOTER //
// ./src/components/deduction-historic-list/index.js